import { Component, inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { Observable, of } from "rxjs"
import { FileContent } from "../../models"
import { FileInputComponent } from "../file-input/file-input.component"

export interface ContractsDialogData {
    employee: string
    rentalAgreement: FileContent
    subrentalAgreement: FileContent
}

@Component({
    selector: "valben-contracts-dialog",
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatDialogClose, MatIcon, FileInputComponent],
    template: `
        <button class="valben-dialog-close" mat-dialog-close aria-label="Zatvori">
            <mat-icon>close</mat-icon>
        </button>

        <h2 mat-dialog-title class="text-lg font-semibold pr-10">Ugovori djelatnika</h2>

        <mat-dialog-content>
            <div class="flex flex-col gap-4">
                @if (data.employee) {
                    <p class="text-lg font-semibold">{{ data.employee }}</p>
                }
                <valben-file-input
                    key="rentalAgreement"
                    [itemObservable]="contracts$"
                    [update]="noop"
                    fileType="application/pdf"
                    [error]="false"
                    [isKng]="true"
                    [preview]="true"
                    [optional]="false"
                    title="Ugovor o najmu">
                </valben-file-input>
                <valben-file-input
                    key="subrentalAgreement"
                    [itemObservable]="contracts$"
                    [update]="noop"
                    fileType="application/pdf"
                    [error]="false"
                    [isKng]="true"
                    [preview]="true"
                    [optional]="false"
                    title="Ugovor o podnajmu">
                </valben-file-input>
            </div>
        </mat-dialog-content>
    `,
})
export class ContractsDialogComponent {
    readonly data = inject<ContractsDialogData>(MAT_DIALOG_DATA)

    contracts$: () => Observable<{ rentalAgreement: FileContent, subrentalAgreement: FileContent }> = () =>
        of({ rentalAgreement: this.data.rentalAgreement, subrentalAgreement: this.data.subrentalAgreement })

    readonly noop = (_value: FileContent) => {}
}
